import React from 'react';
import Papa from "papaparse";
import t from "../../Utils/Translation";
import LykioButton from "../common/LykioButton";

const DownloadCSVButton = ({ data, filename }) => {
    const selectedData = data.map(item => {
        return {
         'Full Name': item.fullName,
         'Email': item.email,
         'Signed up': item.creationDate,
         'Country': item.country,
         'Status': item.status,
         'Description': item.description,
         'Committed': item.committed ? 'Yes' : 'No'
        }
    });

    const downloadCsvHandler = () => {
        // Convert the data to CSV format
        const csv = Papa.unparse(selectedData);// Create a blob from the CSV string
        const blob = new Blob([csv], { type: "text/csv" });// Create a download link and click it programmatically
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click(); // Remove the link after triggering the download
        URL.revokeObjectURL(link.href);
    }; 
     
    return (
        <LykioButton onClick={downloadCsvHandler}  variant="contained">{t('Export users to csv')}</LykioButton>
    );
};

export default DownloadCSVButton;